import { FC } from 'react';

import { isNumber } from 'lodash';
import { AvailableCurrencies, CURRENCY_SYMBOLS, formatCost, formatCostInCents } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { Skeleton, Text, TextTypography } from '@hh.ru/magritte-ui';

import { CELL_TYPOGRAPHY, EMPTY_VALUE } from 'components/CampaignsDashboard/utils/constants';

interface CampaignTableMoneyProps {
    value?: number;
    inCents?: boolean;
    loading?: boolean;
    typography?: TextTypography;
}

export const CampaignTableMoney: FC<CampaignTableMoneyProps> = ({
    value,
    inCents = false,
    loading = false,
    typography = CELL_TYPOGRAPHY,
}) => {
    let formattedValue = EMPTY_VALUE;

    if (isNumber(value)) {
        const formattedAmount = inCents
            ? formatCostInCents(value, NON_BREAKING_SPACE)
            : formatCost(value, NON_BREAKING_SPACE);
        formattedValue = `${formattedAmount}${NON_BREAKING_SPACE}${CURRENCY_SYMBOLS[AvailableCurrencies.RUR]}`;
    }

    return (
        <Text typography={typography}>
            <Skeleton height={16} width={60} borderRadius={4} loading={loading}>
                {formattedValue}
            </Skeleton>
        </Text>
    );
};
